/* import __COLOCATED_TEMPLATE__ from './grow-in-out.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();